import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('admin_token');
  const email = localStorage.getItem('admin_email');

  if (!token || !email) {
    // Redirigir al inicio si no está autenticado
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
